const valueIsNotSet = (value) => value === null || value === 0;

// eslint-disable-next-line import/prefer-default-export
export { valueIsNotSet };
